<script>
import { mapGetters } from 'vuex';
import { useAlert } from 'dashboard/composables';
import { useAccount } from 'dashboard/composables/useAccount';
import WithLabel from 'v3/components/Form/WithLabel.vue';
import NextInput from 'next/input/Input.vue';
import BaseSettingsHeader from '../../settings/components/BaseSettingsHeader.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';
import SectionLayout from '../../settings/account/components/SectionLayout.vue';

export default {
  components: {
    BaseSettingsHeader,
    NextButton,
    SectionLayout,
    WithLabel,
    NextInput,
  },
  setup() {
    const { accountId } = useAccount();
    return { accountId };
  },
  data() {
    return {
      apiKey: '',
    };
  },
  computed: {
    ...mapGetters({
      getAccount: 'accounts/getAccount',
      uiFlags: 'accounts/getUIFlags',
    }),
    currentAccount() {
      return this.getAccount(this.accountId) || {};
    },
    isUpdating() {
      return this.uiFlags.isUpdating;
    },
  },
  watch: {
    'currentAccount.id'(id) {
      if (id) {
        this.initializeAccount();
      }
    },
  },
  mounted() {
    if (this.currentAccount.id) {
      this.initializeAccount();
    }
  },
  methods: {
    initializeAccount() {
      try {
        const { custom_attributes, settings } = this.getAccount(this.accountId);
        this.apiKey = settings?.cetakers_flow_api_key || '';
      } catch (error) {
        // Ignore error
      }
    },
    async updateAccount() {
      try {
        await this.$store.dispatch('accounts/update', {
          settings_flags: {
            cetakers_flow_api_key: this.apiKey,
          },
        });
        useAlert('Konfigurasi Cetakers Flow berhasil disimpan');
      } catch (error) {
        useAlert('Gagal menyimpan konfigurasi');
      }
    },
  },
};
</script>

<template>
  <div class="flex flex-col w-full h-full overflow-auto bg-n-surface-1 p-8">
    <div class="flex flex-col w-full max-w-3xl mx-auto">
      <BaseSettingsHeader
        title="Cetakers Flow"
        description="Konfigurasi integrasi dengan Cetakers Flow"
        icon="i-lucide-layers"
      />
      <div class="flex-grow flex-shrink min-w-0 mt-3">
      <SectionLayout
        title="API Configuration"
        description="Masukkan API Key Cetakers Flow Anda untuk mengaktifkan sinkronisasi invoice dan SPK."
        class="!pt-0"
      >
        <form
          v-if="!uiFlags.isFetchingItem"
          class="grid gap-4"
          @submit.prevent="updateAccount"
        >
          <WithLabel
            name="cetakers-flow-api-key"
            label="API Key"
          >
            <NextInput
              v-model="apiKey"
              type="text"
              class="w-full"
              placeholder="Masukkan API Key..."
            />
          </WithLabel>
          <div>
            <NextButton blue :is-loading="isUpdating" type="submit">
              Simpan Konfigurasi
            </NextButton>
          </div>
        </form>
      </SectionLayout>

      <woot-loading-state v-if="uiFlags.isFetchingItem" />
    </div>
    </div>
  </div>
</template>
